import { Component, inject, signal } from '@angular/core';
import { StackedSnackbarService } from '../../../core/services/stacked-snackbar.service';
import { MatIconModule } from '@angular/material/icon';
import { DatePipe, UpperCasePipe } from '@angular/common';

@Component({
  selector: 'app-stacked-snackbar',
  template: `
    @for (msg of messages(); track $index; let i = $index) {

      <div class="snackbar-item mat-elevation-z4">
        <div class="snackbar-header">
          <div class="snackbar-meta">
            @if (msg?.user) {
              <span>{{ msg?.user?.toString() | uppercase }} </span>
            }
            {{ msg?.date | date: 'dd/MM/yyyy HH:mm:ss' }}
          </div>
          <button mat-icon-button (click)="close(i)" aria-label="Cerrar notificación">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="snackbar-title">{{ msg?.title }}</div>
        @if (msg.subtitle) {
          <div class="snackbar-subtitle">{{ msg?.subtitle }}</div>
        }
        @if (msg?.text) {
          <div class="snackbar-body">{{ msg?.text }}</div>
        }
      </div>
    }
  `,
  styles: [
    `
      .snackbar-item {
        background: #323232;
        color: #fff;
        border-radius: 8px;
        padding: 12px;
        margin-top: 10px;
        min-width: 320px;
        max-width: 430px;
        animation: fadeIn 0.3s ease;
        font-family: Roboto, Arial, sans-serif;
      }

      .snackbar-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 12px;
        color: #bdbdbd;
        margin-bottom: 4px;
      }

      .snackbar-title {
        font-weight: 500;
        font-size: 14px;
        color: #90caf9;
        text-transform: uppercase;
      }

      .snackbar-subtitle {
        font-weight: 500;
        color: #90caf9;
        font-size: 13px;
        margin-bottom: 6px;
      }

      .snackbar-body {
        font-size: 13px;
        line-height: 1.4;
        white-space: pre-wrap;
        text-align: justify;
      }

      button[mat-icon-button] {
        width: 24px !important;
        height: 24px !important;
        line-height: 24px !important;
        padding: 0 !important;
        margin: 0 !important;
      }

      button[mat-icon-button] mat-icon {
        font-size: 16px;
        width: 16px;
        height: 16px;
        line-height: 16px;
      }

      button[mat-icon-button] {
        color: #9e9e9e;
        transition: color 0.2s;
      }

      button[mat-icon-button]:hover {
        color: white;
      }

      @keyframes fadeIn {
        from {
          opacity: 0;
          transform: translateY(-10px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `,
  ],
  imports: [UpperCasePipe, DatePipe, MatIconModule],
})
export class StackedSnackbarComponent {
  messages = signal<{
    date?: Date | string;
    title: string;
    subtitle?: string;
    text?: string;
    user?: string;
  }[]>([]);

  private injectionService = inject(StackedSnackbarService);

  close(index: number) {
    this.injectionService.close(index);
  }
}
